import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import "./ScrollToTop.css";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const { pathname } = useLocation(); // Get current path

  // Immediately reset scroll to top before paint on route change
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      
      const totalScroll = docHeight - winHeight;
      const currentProgress = (scrollTop / totalScroll) * 100;
      setProgress(currentProgress);

      if (scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div 
      className={`scroll-to-top-wrapper ${isVisible ? "active" : ""}`} 
      onClick={scrollToTop}
    >
      <svg className="progress-circle" width="50" height="50" viewBox="0 0 100 100">
        <circle className="progress-background" cx="50" cy="50" r="45" />
        <circle
          className="progress-bar"
          cx="50" cy="50" r="45"
          style={{
            strokeDasharray: 283,
            strokeDashoffset: 283 - (283 * progress) / 100,
          }}
        />
      </svg>
      <div className="arrow-icon-inner">
        <i className="bi bi-chevron-up"></i>
      </div>
    </div>
  );
};

export default ScrollToTop;